import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  props: {
    file: Object,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          name: i18n.t("common.edit"),
          icon: "crop",
        },
        {
          name: i18n.t("common.info"),
          icon: "info",
        },
      ],
    };
  },
  methods: {
    setActiveTab(index) {
      this.activeTab = index;

      //close face editing
      EventBus.$emit(`faces--cancel`);
      EventBus.$emit(`faces-overlay--hide`);

      //reset cropping
      EventBus.$emit(`file-editor-preview--remove`);
    },
  },
};
